import React, { useEffect } from 'react';
import { Grid, Hidden } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Link, Redirect, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import Loader from '@cpg-its/ads.common.loading-circle';
import { useDispatch, useSelector } from 'react-redux';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../constants/routes';
import { TcsmStates } from '../../../../root/tcsm-model';
import { AnnualEnrollmentProps, SearchProps } from '../../models/arc-epi-props';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { ListPagination } from '../../../../search/components/list-pagination';
import { useParticipantState } from './useParticipantState';
import { BillingAccount } from '../billing-accounts/billing-accounts-models';
import { ParticipantView } from './participant-item-view';
import { BillingAddress, CoveredPeople } from './participants-models';
import { setCurrentEmployee, unSetEmploymentState } from '../employment/employment-slice';
import { unloadCompensationState } from '../compensation/compensation-history/compensation-history-slice';
import { unloadPersonState } from '../../../account-info/features/personal-info/personal-info-slice';
import { DemographicAppKeys } from '../../../../global/models/demographics-model';
import { unloadRelationshipState } from '../../../account-info/features/relationships/relationships-slice';
import { unloadDependentState } from '../../../account-info/features/dependents/dependents-slice';
import { SearchBar } from '../../../../search/components/search-bar';
import { ParticipantsListLabels } from './participants-list-label';
import { sortTableStyles } from '../../../../global/constants/theme/styles/tables/generic-sort-table';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
//import { FilterGroup } from '../../../../search/components/filter-group';
//import { RadioFilter } from '../../../../search/components/radio-filter';
//import { FilterOption } from '../../../../search/search-model';
import { AnnualEnrollmentRoutes } from '../../../annual-enrollment/constants/annual-enrollment-routes';
import { AccountInfoRoutes } from '../../../account-info/constants/routes';
import { clearAEInfo } from '../../../annual-enrollment/annual-enrollment-slice';
import { clearMidYearState } from '../mid-year/mid-year-slices';
import { InstitutionState } from '../institutions/institution-model';
import { dispatchResetInstitutionClientNumber, dispatchSetCurrentInstitution, setInstitutionClientNumber } from '../institutions/institution-slice';
import { getOrganization } from '../../../../global/ducks/organization-prc-api';
import { getCurrencyFormat, getPhoneFormat } from '../../../../global/helpers/format-helpers';
import { downloadFileFromApi } from '../../../../global/helpers/file-helpers';
import { ApiEndpoint } from '../../../../global/constants/api-endpoints';
//import { employeeSearchPageStyles } from '../../../../global/constants/theme/styles/employee-search/employee-search-page';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { setEmployeeContext, setNavigationContext } from '../../../../global/ducks/app-context';
import { EmployeeContext, NavigationContext } from '../../../../global/models/app-context-model';
import { ParticipantsEnrollmentRoutes } from '../new-participant-enrollment/models/routes';


interface Props {
	defaultRedirect?: string;
}

export function ParticipantsSearch(props: Props) {
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps.searchSettingsState.epiContent);
	const billingAccountSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}`);
	const participantDemographic = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.BillingAccountsSearch}${ArcRoutes.Participants}${props?.defaultRedirect || ArcRoutes.PersonalInformation}`);
	const annualEnrollment = useBasePath(`${ArcRoutes.ArcRoot}${AnnualEnrollmentRoutes.AnnualEnrollment}${AccountInfoRoutes.PersonalInfoSegment}`);
	const selectedBillingAccount = useSelector<TcsmStates, BillingAccount>(state => state.billingAccountsState?.currentBillingAccount);
	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const institutionDetailLink = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionDetails}`);
	const token = useSelector<TcsmStates, string>(state => state.authenticatedState?.accessToken);
	const annualEnrollmentSettings = useSelector<TcsmStates, AnnualEnrollmentProps>(state => state.epiProps?.annualEnrollmentSettingsState?.epiContent);
	const nepEnrollmentlink = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.ParticipantEnrollment}${ParticipantsEnrollmentRoutes.ParticipantRecord}`);

	const dispatch = useDispatch();
	const history = useHistory();
	const { state } = useLocation<any>();
	const routeMatch = useRouteMatch();
	const participantState = useParticipantState(selectedBillingAccount?.group_id, selectedBillingAccount?.account_number);
	const billingDetail = participantState?.billingAccountDetail;
	const initialList = billingDetail?.covered_people;
	const tableClasses = sortTableStyles();
	const buttonClasses = buttonStyles();
	//const filterClasses = employeeSearchPageStyles();
	const gpsItem = useGpsType(GpsType.PARTICIPANT);
	const allowedAddParticipantGroups = searchSettings?.groupsWhoCanAddParticipants?.split(',');
	useEffect(() => {
		dispatch(unSetEmploymentState());
		dispatch(unloadCompensationState());
		dispatch(unloadPersonState(DemographicAppKeys.arc));
		dispatch(unloadRelationshipState(DemographicAppKeys.arc));
		dispatch(unloadDependentState(DemographicAppKeys.arc));
		dispatch(clearAEInfo(DemographicAppKeys.arc));
		dispatch(clearMidYearState());
	}, []);


	if (!selectedBillingAccount) {
		return (
			<Redirect to={{
				pathname: billingAccountSelect,
				state: {
					actionLink: routeMatch.path,
					finalAction: state?.actionLink,
				},
			}} />);
	}


	const getAddress = (address: BillingAddress) => {
		return `${address?.billing_address_address1 || ''}, ${address?.billing_address_address2 || ''} ${address?.billing_address_city || ''} ${address?.billing_address_state || ''} ${address?.billing_address_postal_code || ''}`;
	};
	const onSetParticipant = (participantGuid: string) => {
		if (initialList) {
			const match = initialList.filter(x => x.guid === participantGuid)[0];
			if (match) {
				dispatch(setCurrentEmployee(match));
				dispatch(setEmployeeContext(EmployeeContext.Participant));
				dispatch(setNavigationContext(NavigationContext.BillingAccount));
			}
		}

		let redirectPage = state?.finalAction || state?.actionLink;

		if (!redirectPage || routeMatch.path.includes(redirectPage)) {
			redirectPage = participantDemographic;
		}

		history.push(redirectPage);
	};

	const annualEnrollmentAction = (guid: string) => {
		if (initialList) {
			const match = initialList.filter(x => x.guid === guid)[0];
			if (match) {
				dispatch(setCurrentEmployee(match));
			}
		}

		history.push(annualEnrollment);
	};

	//const statusFilterOptions: FilterOption[] = searchSettings?.annualEnrollmentStatusFilters?.map((value) => {
	//    return {
	//        filterKey: 'annual_enrollment_status',
	//        filterDisplayValue: value.key,
	//        filterValue: value.value,
	//    };
	//});

	//const defaultStatusFilter = statusFilterOptions?.find((value) => {
	//    return value.filterValue === '';
	//});

	if (!participantState.billingAccountDetailLoaded) {
		return (<Loader />);
	}

	const renderAccountName = () => {
		const institutionMatch = institutionState?.institutionList?.find(inst => inst.client_number === billingDetail?.account_owner_client_number);

		if (!institutionMatch) {
			return <p>{billingDetail?.account_owner_org_name}</p>;
		}

		return (
			<>
				<button
					type='button'
					className={`${buttonClasses.linkButton} input-label`}
					onClick={() => {
						dispatch(setInstitutionClientNumber(institutionMatch.client_number));
						dispatch(setNavigationContext(NavigationContext.Institution));
						dispatch(getOrganization(institutionMatch.client_number, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));
						history.push(institutionDetailLink);
					}}>
					{participantState?.billingAccountDetail?.account_owner_org_name}
				</button>
			</>
		);
	};

	const downloadDocument = () => {
		const requestUrl = `${ApiEndpoint.mlps}/group/${billingDetail?.group_id}/accounts/${billingDetail.billing_account_number}.xlsx`;

		downloadFileFromApi(requestUrl, token, 'employee-list.xlsx');
	};



	return (
		<>
			<Grid container>
				<MainContent>
					<ContentSpacer>
						<h1>{searchSettings.participantSectionTitle}</h1>
					</ContentSpacer>
					<Grid container spacing={1}>
						<Grid item xs={12} lg={6}>
							<ContentSpacer>
								<p className='input-label'>{searchSettings?.billingAccountLabel}</p>
								{renderAccountName()}
								<p>{searchSettings?.billingAccountAddressLabel}: {getAddress(participantState?.billingAccountDetail?.account_owner_billing_address)}</p>
								<p>{searchSettings?.billingAccountPhoneLabel}: {getPhoneFormat(billingDetail.account_phone_country_code, billingDetail.account_phone_area_code, billingDetail.account_phone_number)}</p>
							</ContentSpacer>
						</Grid>
						<Grid item xs={12} lg={6}>
							<ContentSpacer>
								<ContentSpacer>
									<p className='input-label'>{searchSettings?.amountDueLabel}</p><p>{getCurrencyFormat(parseFloat(selectedBillingAccount?.current_amount_due))}</p>
								</ContentSpacer>
								<button
									type='button'
									className={buttonClasses.linkButton}
									onClick={downloadDocument}>
									<GetAppIcon />
									<span>{searchSettings?.downloadEmployeeListButtonText}</span>
								</button>
							</ContentSpacer>
						</Grid>
					</Grid>
					{
						allowedAddParticipantGroups?.some(gid => gid === selectedBillingAccount?.group_id.toString()) &&
						<Grid container spacing={1}>
							<Grid item xs={12} lg={6}>
								<ContentSpacer>
									<Link className={buttonClasses.primaryButton} to={nepEnrollmentlink}>{searchSettings?.addParticipantButtonText}</Link>
								</ContentSpacer>
							</Grid>
						</Grid>
					}
				</MainContent>

				<SideBarContent>
					<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
				</SideBarContent>

			</Grid>


			<SearchApp initialList={initialList} appName={`${selectedBillingAccount?.account_number}-BillingAccountSearch`}>
				<Grid container>

					<Hidden lgUp>
						{
							initialList?.length >= 10 &&
							<MainContent>
								<SearchBar label={searchSettings.billingAccountSearchBarText} name='participant-search-bar' filterProps={['full_name', 'mailing_address_city', 'ae_available']} />
							</MainContent>

						}
					</Hidden>
					{
						/*
						   <FilterGroup hide={initialList?.length < 10} >
						   <Grid className={filterClasses.searchFilters} item xs={12} lg={3}>
							   <Grid item xs={12}>
								   <ContentSpacer>
									   <h2>{searchSettings?.participantsFilterSectionTitle}</h2>
								   </ContentSpacer>
							   </Grid>
							   <Grid className='filters-group' item xs={12} md={4} lg={12}>
								   <RadioFilter
									   name='annual_enrollment_status'
									   defaultValue={defaultStatusFilter}
									   options={statusFilterOptions}
									   label={searchSettings?.annualEnrollmentStatusFilterLabel}
								   />
							   </Grid>
   
						   </Grid>
						   </FilterGroup>
					   */
					}
					<Grid item xs>
						<Hidden mdDown>
							{
								initialList?.length >= 10 &&
								<MainContent>
									<SearchBar label={searchSettings.billingAccountSearchBarText} name='participant-search-bar' filterProps={['full_name', 'mailing_address_city', 'ae_available']} />
								</MainContent>

							}
						</Hidden>
						<div className={tableClasses.sortTable}>

							<Hidden xsDown>
								<ParticipantsListLabels settings={searchSettings} annualEnrollmentDisabled={annualEnrollmentSettings?.disableAnnualEnrollment} />
							</Hidden>
							<div className='sort-table-content'>
								<SearchList
									renderList={
										(item) => {
											return <ParticipantView
												settings={searchSettings}
												key={(item as CoveredPeople).guid}
												item={item}
												onSetParticipants={() => { onSetParticipant((item as CoveredPeople).guid); }}
												annualEnrollmentAction={() => { annualEnrollmentAction((item as CoveredPeople).guid); }}
												annualEnrollmentDisabled={annualEnrollmentSettings?.disableAnnualEnrollment}
											/>;
										}
									}
									renderPagination={
										(totalCounts, name) => {
											return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings.nextButton} prevButton={searchSettings.previousButton} />;
										}
									}
									emptyMessage={searchSettings.emptyListMessage}
								/>
							</div>
						</div>
					</Grid>
				</Grid>
			</SearchApp>

		</>
	);
}


ParticipantsSearch.defaultProps = {
	defaultRedirect: null,
};